import { connect as formikConnect, Field } from 'formik';
import range from 'lodash/range';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../../lib/utils/css';
import { FormItemTypes } from '../../constants';
import * as FormUtils from '../../utils';
import { DateOptionLabels } from '../constants';

/**
 * @param  {string} label - Title for select
 * @param  {object} inputAttributes - Provides data to create select
 * @param  {Any} formik - Provided by formik connect
 */

class FormSelectDay extends React.Component {
  static propTypes = {
    label: PropTypes.node,
    inputAttributes: PropTypes.shape({
      name: PropTypes.string,
      qaTag: PropTypes.string,
    }),
    formik: PropTypes.object,
  };

  generateDayOptions = () => {
    return range(0, 32).map(val => {
      if (val === 0) {
        return (
          <option value='-1' key='-1'>
            {DateOptionLabels.DAY}
          </option>
        );
      }
      return (
        <option value={val} key={val}>
          {val}
        </option>
      );
    });
  };

  render() {
    const { formik, label, inputAttributes } = this.props;
    const { name, qaTag } = inputAttributes;
    const selectClasses = createBEM('Form__select', {
      error: FormUtils.shouldShowError(formik, name),
    });
    return (
      <Field
        className={selectClasses}
        name={name}
        title={label}
        data-qa={qaTag}
        component={FormItemTypes.SELECT}
      >
        {this.generateDayOptions()}
      </Field>
    );
  }
}

export default formikConnect(FormSelectDay);
